module.exports = __webpack_public_path__ + "img/9b03a2b.png";